import { difficultyToStr } from '@/launcher/helpers';
import { createUserModel } from '@/core/shared/auth/store/models';

export default (schema, store) => {
  const User = createUserModel(schema);
  const Organization = new schema.Entity('Organization', {});
  const Location = new schema.Entity('Location', {});
  const Locale = new schema.Entity(
    'Locale',
    {},
    {
      idAttribute: 'key',
    },
  );
  const Video = new schema.Entity('Video', {});
  const Game = new schema.Entity(
    'Game',
    {},
    {
      processStrategy (value) {
        const result = { ...value };
        result.difficultyName = difficultyToStr(result.difficulty);
        result.videoSource = result.videoUrl && {
          type: 'video/webm',
          src: result.videoUrl,
        };
        return result;
      },
    },
  );
  const StationTag = new schema.Entity('StationTag', {
    games: [Game],
  });
  const Station = new schema.Entity(
    'Station',
    {
      organization: Organization,
      location: Location,
      playing: Game,
    },
    {
      processStrategy (value) {
        const result = { ...value };
        result.running = store.getters.playingGame;
        return result;
      },
    },
  );

  return {
    User,
    Game,
    StationTag,
    Station,
    Organization,
    Location,
    Locale,
    Video,
  };
};
